import React, { useEffect, useState } from 'react'

import { LeafHero, Spinner } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import { useQuery } from '@apollo/react-hooks'
import styled from 'styled-components'

import { Friend } from 'generated/types'
import theme from 'theme'

import friendQuery from './gql/friend.query.gql'

type Props = {
  handleError: () => void
  handleFinishLoading: () => void
  userSource: string
}

type FriendDetails = {
  friend: Friend
}

const Hero = styled(LeafHero)`
  padding: 35px;
  margin-bottom: 40px;
  height: fit-content;

  .leaf-hero-text {
    max-width: none;
    line-height: 22px;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-bottom: 30px;
    padding: 33px 19px;
  }
`

export const Banner = (props: Props) => {
  const isUserReferral = props.userSource.toLowerCase() === 'referrals'
  const { loading: isLoadingData, data: friendData } = useQuery<FriendDetails>(friendQuery, {
    fetchPolicy: 'network-only',
    skip: !isUserReferral,
  })
  const { getRemoteString, isLoadingRemoteStrings, StyledRemoteString } = useRemoteStrings()
  const [advocateInfo, setAdvocateInfo] = useState({
    firstName: '',
    lastName: '',
    incentive: '',
  })

  useEffect(() => {
    if (isUserReferral && !isLoadingData) {
      const experienceContent = friendData?.friend?.friendExperienceContent
      if (!experienceContent) {
        props.handleError()
      } else {
        setAdvocateInfo({
          firstName: experienceContent.advocateFirstName ?? '',
          lastName: experienceContent.advocateLastName ?? '',
          incentive: experienceContent.advocateMinimumIncentive ?? '',
        })
        props.handleFinishLoading()
      }
    }
  }, [isLoadingData, isUserReferral])

  const bannerText = isUserReferral ? (
    <StyledRemoteString
      stringKey={'referral_disclosure.advocate_disclaimer.2variable.markdown'}
      variables={[`${advocateInfo.firstName} ${advocateInfo.lastName}`, advocateInfo.incentive]}
      modifiers={[{ bold: 600 }]}
    />
  ) : (
    getRemoteString({ key: 'referral_disclosure.advocate_disclaimer.generic' })
  )

  const message =
    (isUserReferral && (isLoadingData || !advocateInfo.firstName.length)) ||
    isLoadingRemoteStrings ? (
      <Spinner />
    ) : (
      bannerText
    )

  return <Hero header={''} text={message} />
}
